import { useContext, createContext } from "react";
import { Button, Card, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

import { masterPageStore as MasterPageStore } from "../store/MasterPageStore";
import IMG1 from "../img/baba1.jpg"
import IMG2 from "../img/baba7.jpeg"
import IMG3 from "../img/baba3.jpg"
import IMG4 from "../img/baba4.jpg"
import IMG5 from "../img/baba5.jpg"
import IMG6 from "../img/baba6.jpeg"
import IMG8 from "../img/baba8.jpeg"
import logo from "../../Home/img/logo.gif"
import { getCurrentUser } from "../../../Utility/helper";
import { permissionStore } from "../store/PermissionStore";
import "../styles/landingMainPageStyle.css"
import { homeStore } from "../../Home/store/HomeStore";
import { signUpView } from "../../Home/types/interfaces";
// const { useDevice } = require("react-use-device");
type Props = {};
const greet = require("greet-by-time");
const masterPageStoreCtx = createContext(MasterPageStore);
const permissionStoreCtx = createContext(permissionStore);
const { Meta } = Card;
const LandingMainPage = (props: Props) => {
  // let { reqId } = useParams();
  const hour = new Date().getHours();
  greet.morningGreetings = ["Good Morning", "Awesome Morning", "Welcome Back"];
  greet.dayGreetings = ["Good Afternoon", "Awesome Afternoon", "Welcome Back"];
  greet.eveningGreetings = ["Good Evening", "Awesome Evening", "Welcome Back"];
  const masterPageStore = useContext(masterPageStoreCtx);
  // const ManageFacilityStore = useContext(manageFacilityStoreCtx);
  const PermissionStore = useContext(permissionStoreCtx);
  let navigate = useNavigate();
  const user = getCurrentUser()?.fullName;
  // const { isMOBILE, isDESKTOP,isTABLET } = useDevice();
  const year = (new Date()).getFullYear();

  return (
    <>
      <div>
        <nav className="navbar">
          <div className="logo">
            <img src={logo} alt="Logo" />
            <p>ESOCS DATA BANK</p>
          </div>
          <div className="nav-links">
            <Space
              align="end"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Button
                type="link"
                htmlType="button"
                onClick={() => {
                  homeStore.signUpView = signUpView.Login;
                  navigate("/login");
                }}
                style={{ color: "#fff" }}
                className="ms-sm12 ms-fontSize-12"
              >
                Login
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => {
                  homeStore.signUpView = signUpView.Register;
                  navigate("/login");
                }}
                style={{ color: "#fff" }}
                className="ms-sm12 ms-fontSize-12"
              >
                Sign Up Now
              </Button>
            </Space>
          </div>
        </nav>

        <header>
          <h1>Welcome to ESOCS DATA BANK</h1>
          <p>We are glad to have you!</p>
        </header>

        <div className="leaders-container">
          <h2 className="section-title">Our Church Leaders</h2>

          {/* Featured Leader */}
          <div className="featured-leader">
            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG5} alt="His Most Eminence, Baba Aladura" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS MOST EMINENCE, BABA ALADURA</p>
                <h2 className="leader-name">(DR) DAVID D.L BOBMANUEL</h2>
              </div>
            </div>
          </div>

          {/* Deputy Leaders Grid */}
          <div className="leaders-grid">
            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG4} alt="His Eminence, Deputy Baba Aladura" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
                <h2 className="leader-name">NATHAN OJIAKOR</h2>
              </div>
            </div>

            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG3} alt="His Eminence, Deputy Baba Aladura" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
                <h2 className="leader-name">J. F. FARINLOYE</h2>
              </div>
            </div>

            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG1} alt="His Eminence, Deputy Baba Aladura" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE, DEPUTY BABA ALADURA</p>
                <h2 className="leader-name">(DR) HAROLD DUMUREN</h2>
              </div>
            </div>
          </div>

          {/* Secondary Leaders Grid (New Row) */}
          <div className="secondary-leaders-grid">
            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG6} alt="Leader" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE</p>
                <h2 className="leader-name">DEPUTY BABA ALADURA JIMMY NKPOIDET</h2>
              </div>
            </div>

            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG8} alt="Leader" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE</p>
                <h2 className="leader-name">DEPUTY BABA ALADURA DR. ISAAC BELLO</h2>
              </div>
            </div>
          </div>

          {/* Single Leader */}
          <div className="single-leader">
            <div className="leader-card">
              <div className="leader-image-container">
                <img src={IMG2} alt="Deputy Baba Aladura" />
              </div>
              <div className="leader-info">
                <p className="leader-title">HIS EMINENCE, ELDER, SECRETARY TO THE ORDER</p>
                <h2 className="leader-name">(DR) DR. I. U. OMOIKE</h2>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <p>&copy; ESOCS Data Bank {year} | All Rights Reserved</p>
        </footer>
      </div>
    </>
  );
};


export default LandingMainPage;
